<template>
  <div class="pa-2">
    <v-tabs v-model="tab" color="red-darken-1" class="mb-3">
      <v-tab value="concedii">Cereri Concediu</v-tab>
      <v-tab value="documente">Cereri Documente</v-tab>
    </v-tabs>

    <v-window v-model="tab">
      <!-- Concedii -->
      <v-window-item value="concedii">
        <DxDataGrid :data-source="dsConcedii" :show-borders="true" :row-alternation-enabled="true" :remote-operations="true">
          <DxColumn data-field="DataCreare" caption="Data" data-type="datetime" format="dd.MM.yyyy" :width="120" />
          <DxColumn data-field="AngajatID" caption="Angajat ID" :width="300" />
          <DxColumn data-field="DataInceput" caption="Start" data-type="date" format="dd.MM.yyyy" :width="110" />
          <DxColumn data-field="DataSfarsit" caption="Sfârșit" data-type="date" format="dd.MM.yyyy" :width="110" />
          <DxColumn data-field="NumarZile" caption="Zile" :width="70" />
          <DxColumn data-field="TipConcediu" caption="Tip" :width="100" />
          <DxColumn data-field="Stare" caption="Stare" :width="130" cell-template="stareCellTemplate" />
          <DxColumn data-field="Descriere" caption="Observații" />

          <template #stareCellTemplate="{ data }">
            <v-chip :color="stareColorConcediu(data.data.Stare)" size="small" variant="tonal">{{ stareLabel(data.data.Stare) }}</v-chip>
          </template>

          <DxFilterRow :visible="true" />
          <DxPaging :page-size="20" />
          <DxSearchPanel :visible="true" :width="200" placeholder="Caută..." />
          <DxToolbar>
            <DxItem location="after" name="searchPanel" />
            <DxItem location="after"><template #default><DxButton icon="refresh" @click="dsConcedii.reload()" /></template></DxItem>
          </DxToolbar>
        </DxDataGrid>
      </v-window-item>

      <!-- Cereri Documente -->
      <v-window-item value="documente">
        <DxDataGrid :data-source="dsDocumente" :show-borders="true" :row-alternation-enabled="true" :remote-operations="true">
          <DxColumn data-field="DataCreare" caption="Data" data-type="datetime" format="dd.MM.yyyy" :width="120" />
          <DxColumn data-field="AngajatID" caption="Angajat ID" :width="300" />
          <DxColumn data-field="Stare" caption="Stare" :width="130" cell-template="stareDocCellTemplate" />
          <DxColumn data-field="Descriere" caption="Descriere" />
          <DxColumn data-field="ObsevatieRaspuns" caption="Răspuns HR" />

          <template #stareDocCellTemplate="{ data }">
            <v-chip :color="stareColorDoc(data.data.Stare)" size="small" variant="tonal">{{ data.data.Stare }}</v-chip>
          </template>

          <DxFilterRow :visible="true" />
          <DxPaging :page-size="20" />
          <DxSearchPanel :visible="true" :width="200" placeholder="Caută..." />
          <DxToolbar>
            <DxItem location="after" name="searchPanel" />
            <DxItem location="after"><template #default><DxButton icon="refresh" @click="dsDocumente.reload()" /></template></DxItem>
          </DxToolbar>
        </DxDataGrid>
      </v-window-item>

    </v-window>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import {
  DxDataGrid, DxColumn, DxEditing, DxPopup, DxForm, DxItem,
  DxToolbar, DxSearchPanel, DxPaging, DxFilterRow
} from 'devextreme-vue/data-grid'
import { DxButton } from 'devextreme-vue/button'
import DataSource from 'devextreme/data/data_source'
import ODataStore from 'devextreme/data/odata/store'
import AppSettings from '@/settings/appSettings'

function makeODataSource(entitySet: string) {
  return new DataSource({
    store: new ODataStore({
      url: AppSettings.API_Url_PortalHROdata + entitySet,
      key: 'ID',
      version: 4,
      beforeSend: (e: any) => {
        e.headers = { Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt') }
      }
    })
  })
}

export default defineComponent({
  name: 'AprobariPortalHR',
  components: { DxDataGrid, DxColumn, DxEditing, DxPopup, DxForm, DxItem, DxToolbar, DxSearchPanel, DxPaging, DxFilterRow, DxButton },
  data() {
    return {
      tab: 'concedii',
      dsConcedii: makeODataSource('PORTAL_CereriConcedii'),
      dsDocumente: makeODataSource('PORTAL_CerereDocument'),
    }
  },
  methods: {
    stareColorConcediu(s: string) {
      const m: Record<string, string> = { in_asteptare: 'amber', aprobata: 'green', respinsa: 'red', '-2': 'grey' }
      return m[s] ?? 'grey'
    },
    stareColorDoc(s: string) {
      const m: Record<string, string> = { noua: 'blue', in_lucru: 'amber', finalizata: 'green', respinsa: 'red' }
      return m[s] ?? 'grey'
    },
    stareLabel(s: string) {
      const m: Record<string, string> = { in_asteptare: 'În așteptare', aprobata: 'Aprobată', respinsa: 'Respinsă', '-2': 'Anulată' }
      return m[s] ?? s
    }
  }
})
</script>
